<template>
  <div>
    <CallHelpTel />
  </div>
  <div>
    <Search @upateShowNews="keywordSearch"></Search>
  </div>
  <template v-for="video in videoList" :key="video.id">
    <VideoBlock :video="video" justify="VideoInner" />
  </template>

  <a-pagination
    v-model:current="pagination.current"
    v-model:total="pagination.total"
    v-model:pageSize="pagination.pageSize"
    @change="onChange"
    :style="{ fontSize: fontSize.p + 'em' }"
  ></a-pagination>
</template>

<script>
import CallHelpTel from "../components/Home/CallHelpTel.vue";
import VideoBlock from "../components/VideoContentB.vue";
import Search from "../components/Search.vue";
import { ref, reactive, inject } from "vue";
import { apiVideoShare } from "@/api/api.js";
import { useStore } from "vuex";

export default {
  name: "Video",
  components: {
    VideoBlock,
    Search,
    CallHelpTel,
  },
  setup() {
    const store = useStore();

    //  無障礙文字子層引入設定
    let fontSize = inject("fontSize");
    // 新聞內容
    const videoList = reactive([]);
    // 分頁資料
    const pagination = reactive({
      total: 0,
      current: 1,
      pageSize: 10,
    });

    // 關鍵字
    let keyword = ref("");
    keyword.value = store.getters["getSearchKeyword"];
    // 切換分頁
    const onChange = (page, pageSize) => {
      pagination.pageSize = pageSize;
      pagination.current = page;
      getNews();
    };

    // 進入網頁是執行
    pagination.current = store.getters["getSearchPage"];
    getNews();

    // 取得新聞資料
    function getNews() {
      store.dispatch("setSearchData", {
        keyword: keyword.value,
        page: pagination.current,
      });
      apiVideoShare({
        keyword: keyword.value,
        page: pagination.current,
      })
        .then((res) => {
          videoList.length = 0; //清空，不然會一直累加
          res.data.videos.forEach((video) => {
            videoList.push(video);
          });
          //不用再const
          pagination.current = res.data.currentPage;
          //這邊是抓總比數但totalPage是總頁數所以要再乘十才是總比數
          pagination.total = res.data.totalPage * 10;
        })
        .catch(function (err) {
          console.log(err);
        });
    }
    // 關鍵字搜尋
    function keywordSearch(str) {
      keyword.value = str;
      pagination.current = 1;
      getNews();
    }
    return {
      videoList,
      pagination,
      getNews,
      keywordSearch,
      onChange,
      fontSize,
    };
  },
};
</script>
